import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  QrCode, 
  Receipt, 
  Clock, 
  Monitor 
} from 'lucide-react';
import '../../../assets/styles/customer/layout/FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      id: 1,
      icon: <QrCode size={52} strokeWidth={1.5} />,
      title: 'QR-Based Tracking',
      description: 'Scan QR codes to log daily milk deliveries',
      gradient: 'linear-gradient(135deg, #3e96e7 0%, #2575c7 100%)',
      iconBg: 'rgba(62, 150, 231, 0.15)'
    },
    {
      id: 2,
      icon: <Receipt size={52} strokeWidth={1.5} />,
      title: 'Automated Billing',
      description: 'Generate accurate monthly invoices',
      gradient: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
      iconBg: 'rgba(255, 193, 7, 0.15)'
    },
    {
      id: 3,
      icon: <Clock size={52} strokeWidth={1.5} />,
      title: 'Real-Time Milk Logs',
      description: 'Track daily milk distribution with real-time logs',
      gradient: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
      iconBg: 'rgba(76, 175, 80, 0.15)'
    },
    {
      id: 4,
      icon: <Monitor size={52} strokeWidth={1.5} />,
      title: 'Web & Mobile System',
      description: 'Manage everything on web & mobile app',
      gradient: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)',
      iconBg: 'rgba(156, 39, 176, 0.15)'
    }
  ];

  return (
    <section className="features-section">
      <Container>
        
        {/* Section Header */}
        <div className="features-header text-center">
          <h2 className="features-title">Key Features</h2>
          <p className="features-subtitle">
            Simplify and automate your <span className="highlight-word">milk distribution</span>!
          </p>
        </div>

        {/* Features Cards Grid */}
        <Row className="g-4 features-cards-row">
          {features.map((feature, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={feature.id}>
              <div 
                className="feature-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Icon Container */}
                <div 
                  className="feature-icon-wrapper"
                  style={{ background: feature.iconBg }}
                >
                  <div 
                    className="feature-icon"
                    style={{ background: feature.gradient }}
                  >
                    {feature.icon}
                  </div>
                </div>

                {/* Card Content */}
                <h3 className="feature-card-title">{feature.title}</h3>
                <p className="feature-card-description">{feature.description}</p>

                {/* Hover Glow Effect */}
                <div 
                  className="feature-card-glow"
                  style={{ background: feature.gradient }}
                ></div>
              </div>
            </Col>
          ))}
        </Row>

      </Container>

      {/* Background Wave */}
      <div className="features-bg-wave">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.05)" 
            d="M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,133.3C672,117,768,107,864,112C960,117,1056,139,1152,138.7C1248,139,1344,117,1392,106.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default FeaturesSection;